const initial = document.querySelector('.js-initial');
const trigger = document.querySelectorAll('.js-filter-trigger');
const dismiss = document.querySelectorAll('button[data-dismiss]');

if (trigger) {
    trigger.forEach(function (item, i) {
        item.addEventListener('click', (e) => {
            let current = e.currentTarget;
            let filter = current.parentElement;
            console.log(current);
            console.log(filter);

            if (e.currentTarget === item) {
                item.setAttribute('aria-expanded', item.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
                filter.classList.toggle('active');
            }

            if (e.currentTarget !== item) {
                item.setAttribute('aria-expanded', 'false');
                filter.classList.remove('active');
            }
        }, false);
    });
}

if (initial) {
    window.addEventListener('click', (e) => {
        if (e.target === initial) {
            e.preventDefault();
            initial.classList.toggle('is-active');
            initial.setAttribute('aria-expanded', initial.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
        }

        if (e.target !== initial) {
            initial.classList.remove('is-active');
            initial.setAttribute('aria-expanded', 'false');
        }
    }, false);
}

if (dismiss.length > 0) {
    for (let i = 0; i < dismiss.length; i++) {
        dismiss[i].addEventListener('click', (e) => {
            e.preventDefault();
            let item = e.target;
            let clName = item.dataset.dismiss;
            let parent = item.closest('.' + clName);
            if (parent) { parent.remove(); }
        }, false);
    }
}

// Select2
$(document).ready(function () {
    $('.input-select2').select2({
        placeholder: 'Select an option...',
        allowClear: true
    });
});
